import { get, set, del } from 'idb-keyval';

// Estructura del Borrador
export interface DraftData {
    uuid: string;         
    timestamp: number;
    payload: any;        
}

export const PersistenceService = {
    getKey: (procedureId: number) => `draft_procedure_${procedureId}`,

    async save(procedureId: number, data: DraftData) {
        try {
            await set(this.getKey(procedureId), data);
        } catch (e) {
            console.warn('No se pudo guardar el borrador (posiblemente modo incógnito)', e);
        }
    },

    async load(procedureId: number): Promise<DraftData | undefined> {
        try {
            return await get(this.getKey(procedureId));
        } catch (e) {
            return undefined;
        }
    },

    async clear(procedureId: number) {
        await del(this.getKey(procedureId));
    }
};